jQuery(document).ready(function(){

  
});
  



function init(){
  
  $('.search-submit').click(function (e) {
    if (!$('.search_container input').hasClass("expanded")) {
      e.preventDefault();
      e.stopPropagation();
        $('.search_container input').toggleClass('expanded');
        $('.search_container input').show(100);
    }

  });
    
  
  /* Change Geolocation App selectbox in footer by switching currency in theme top-nav menu */
  if ($(window).width() >= 798) {
    var $currencySelector = $(".top_bar .currencies");
  } else {
    var $currencySelector = $("#mobile_menu .currencies");
  }
  
  
  var select = $currencySelector;

  if (localStorage.getItem("select") === null) {
    var lastSelected = localStorage.getItem('select');
    select.value = lastSelected;
  } 


  //var selectOption = select.options[select.selectedIndex];
  var selectOption = jQuery( ".menu.right .currencies option:selected" ).val();
  var lastSelected = localStorage.getItem('select');
  if( lastSelected ) {
    select.value = lastSelected; 
    jQuery( '.menu.right .currencies option[value="' + lastSelected + '"]' ).prop('selected', 'selected');
  } else {

  }

  // console.log('LAST SELECTED:' + lastSelected);
  // console.log('SELECTOR:' + $currencySelector);
  
  
  jQuery( $currencySelector ).change(function() {
    
    /* Geolocation switch on change std theme selectbox in top-nav */
    
    // lastSelected = select.options[select.selectedIndex].value;
    //console.log('HEY ' + lastSelected);

    /* Save top-nav lng selectbox val to LocalStorage - show same val on other pages */
    var newSelected = $(this).val();
    localStorage.setItem('select', newSelected);
    // localStorage.setItem('select', lastSelected);
    
    
    var lng = jQuery( ".menu.right .currencies option:selected" ).val();

    jQuery('body div .locale-selectors__container form > select > option[value="' + lng + '"]').prop('selected', 'selected'); 
    jQuery("body div .locale-selectors__container form").submit();
  });
  
}


  
  

if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
  // if doc. already loaded, init. script
  init();
} else{
  // otherwise, wait for DOMContentLoaded event and then fire init()
  document.addEventListener("DOMContentLoaded", init, false );
}